import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { deleteAction, getAction, httpAction } from '@/api/manage';
export default {
  name: 'workFLow',
  props: {
    createBy: {
      type: String | Number,
      default: 0
    },
    //该条项目发起人
    flowSrc: {
      type: String,
      default: 'om_feed_back'
    },
    srcId: {
      type: String | Number,
      default: 0
    } //该条项目id

  },
  data: function data() {
    return {
      confirLoading: false,
      userInfo: this.$store.getters.userInfo,
      flowData: {
        userId: 1,
        flowSrc: "om_feed_back",
        srcId: 3,
        workFlowItemList: []
      },
      currentStatusId: 0,
      //当前流程的id
      currentUserStatus: false,
      //当前用户是否可编辑状态
      flowIndex: 0,
      flowList: []
    };
  },
  mounted: function mounted() {
    console.log('userInfo', this.userInfo);
    this.getFlowUser();
  },
  methods: {
    // 流程撤销
    onToDelete: function onToDelete() {
      var _this = this;

      this.confirLoading = true;
      deleteAction("/sys/work/flow?id=".concat(this.flowData.id), {}).then(function (res) {
        if (res.success) {
          _this.$message.success('撤销成功!');

          _this.$emit('close');
        } else {
          _this.$message.error(res.message);
        }
      }).finally(function () {
        _this.confirLoading = false;
      });
    },
    // 流程发起
    onToStart: function onToStart() {
      var _this2 = this;

      var startState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var agreeFlag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var method = startState ? 'post' : 'put'; // 区分发起与审批

      var flowData = JSON.parse(JSON.stringify(this.flowData));
      var postDatas = {
        userId: this.userInfo.id,
        flowSrc: flowData.flowSrc,
        srcId: flowData.srcId,
        workFlowItemList: []
      };

      if (this.flowIndex == 0) {
        postDatas.workFlowItemList = [{
          userId: this.userInfo.id,
          suggest: flowData.workFlowItemList[this.flowIndex].suggest
        }];
      } else {
        postDatas.id = flowData.id;
        postDatas.workFlowItemList = [{
          userId: this.userInfo.id,
          suggest: flowData.workFlowItemList[this.flowIndex].suggest,
          agreeFlag: agreeFlag
        }];
      }

      console.log('postDatas', postDatas);
      this.confirLoading = true;
      httpAction("/sys/work/flow", postDatas, method).then(function (res) {
        if (res.success) {
          _this2.$message.success(startState ? '发起成功' : '审批成功');

          _this2.$emit('close');
        } else {
          _this2.$message.error(res.message);
        }
      }).finally(function () {
        _this2.confirLoading = false;
      });
    },
    getFlowUser: function getFlowUser() {
      var _this3 = this;

      getAction('/sys/work/flow/getAllWorkFlow', {
        userId: this.createBy
      }).then(function (res) {
        if (res.success) {
          var state = res.result.workFlowItemList.every(function (item) {
            return item.approvalUser.length > 0;
          });

          if (!state) {
            _this3.$message.error('未获取到审批用户，请检查用户部门或岗位是否配置正确');
          } else {
            var obj = [];
            res.result.workFlowItemList = res.result.workFlowItemList.map(function (item) {
              delete item.agreeFlag;
              obj[item.statusId] = item;
            });
            _this3.flowList = obj;
            console.log('flowList', _this3.flowList);

            _this3.getFlowData();
          }
        } else {
          _this3.$message.error('未获取到审批用户，请检查用户部门或岗位是否配置正确');
        }
      });
    },
    getFlowData: function getFlowData() {
      var _this4 = this;

      var srcId = this.srcId;
      getAction("/sys/work/flow", {
        flowSrc: this.flowSrc,
        srcId: srcId
      }).then(function (res) {
        if (res.success) {
          _this4.flowData = {
            userId: _this4.userInfo.id,
            flowSrc: _this4.flowSrc,
            srcId: srcId,
            workFlowItemList: []
          };
          var currentPushState = false;

          if (res.result.records.length > 0) {
            var data = res.result.records[res.result.records.length - 1];
            _this4.flowData = _objectSpread(_objectSpread({}, data), _this4.flowData);
            _this4.flowIndex = data.workFlowItemList.length;
            _this4.currentStatusId = data.workFlowItemList[_this4.flowIndex - 1].nextStatusId;
            _this4.flowData.id = data.id;
            data.workFlowItemList = data.workFlowItemList.map(function (item) {
              item = _objectSpread(_objectSpread({}, _this4.flowList[item.statusId - 0]), item); // 返回的statusId为-1代表流程结束

              if (item.statusId - 0 > -1) {
                item.approvalUser = _this4.flowList[item.statusId - 0].approvalUser;
              } else {
                item.approvalUser = [];
              }

              return item;
            });
            _this4.flowData.workFlowItemList = data.workFlowItemList;
          } else {
            // 发起部分
            _this4.flowIndex = 0;
            if (_this4.createBy != _this4.userInfo.id) return;
          }

          for (var i = 0; i < _this4.flowList.length; i++) {
            var item = _this4.flowList[i];

            if (_this4.currentStatusId == item.statusId) {
              _this4.flowData.workFlowItemList.push(_objectSpread({}, item));

              currentPushState = true;
              continue;
            }

            if (currentPushState) {
              _this4.flowData.workFlowItemList.push(_objectSpread({}, item));
            }
          } // 处理当前用户是否有审批权限


          if (_this4.currentStatusId > -1) {
            _this4.flowList[_this4.currentStatusId].approvalUser.forEach(function (item) {
              if (item.id == _this4.userInfo.id) {
                _this4.currentUserStatus = true;
              }
            });
          }

          console.log('workFlowItemList', _this4.flowData.workFlowItemList);
        } else {
          _this4.$message.error(res.message);
        }
      });
    }
  }
};